import React from 'react';
import { connect } from 'react-redux';
import { WebsiteState } from '@gift/website-state/store';
import { Cell } from '@gift/ui/components/grid/Cell';
import { OrderButton } from './order-button/OrderButton';
import { PrefabPicker } from './prefab-picker/PrefabPicker';
import { Json } from '@gift/types/Json';
import { VariableInputControlSlot } from './VariableInputControlSlot';
import { Grid } from '@gift/ui/components/grid/Grid';
import { selectNonPinnedVariables, selectPinnedVariables } from '@gift/website-state/slices/variablesSlice';
import { selectFilteredPrefabs } from '@gift/basic-scene-website/_redux-prefabs';

const _BasicDesignerUi = ({ pinnedVariables, nonPinnedVariables, hasPrefabs }: Props) => (
    <Grid gap='l' direction='column'>
        {pinnedVariables.map(variable => (
            <VariableInputControlSlot
                key={variable.id}
                variableIds={[variable.id]}
                render={(Control) => (<Cell><Control /></Cell>)} />
        ))}

        {hasPrefabs && (
            <Cell>
                <PrefabPicker />
            </Cell>
        )}

        {nonPinnedVariables.map(variable => (
            <VariableInputControlSlot
                key={variable.id}
                variableIds={[variable.id]}
                render={(Control) => (<Cell><Control /></Cell>)} />
        ))}

        <Cell>
            <OrderButton />
        </Cell>
    </Grid>
);

type Props = {
    pinnedVariables: Json.Variable<any>[],
    nonPinnedVariables: Json.Variable<any>[],
    hasPrefabs: boolean
}

const mapStateToProps = (state: WebsiteState) => ({
    pinnedVariables: selectPinnedVariables(state),
    nonPinnedVariables: selectNonPinnedVariables(state),
    hasPrefabs: selectFilteredPrefabs(state).length > 0
});

export const BasicDesignerUi = connect(
    mapStateToProps
)(_BasicDesignerUi);
